/**
 * Checks if a URL is a Slack URL.
 */
export const isSlackUrl = (urlString: string): boolean => {
	try {
		const url = new URL(urlString);
		return url.hostname.includes('slack.com');
	} catch {
		return false;
	}
};
